export interface ApiError {
  message: string;
  show: boolean;
  status?: number;
}

export enum ErrorCodes {
  LOGIN_TOKEN_EXPIRED = "LOGIN_TOKEN_EXPIRED",
}
